import React from 'react';
import css from './Input.module.css';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  error?: string;
};

export const Input: React.FC<InputProps> = ({ label, error, type = 'text', className = '', ...props }) => {
  if (type === 'checkbox') {
    return (
      <div className={css.checkboxWrapper}>
        {label && <label className={css.checkboxLabel}>{label}</label>}
        <input
          type="checkbox"
          className={[css.checkbox, className].filter(Boolean).join(' ')}
          {...props}
        />
      </div>
    );
  }
  return (
    <div className={css.inputWrapper}>
      {label && <label className={css.label}>{label}</label>}
      <div className={css.inputWrapper}>
        <input
          type={type}
          className={[css.input, className].filter(Boolean).join(' ')}
          {...props}
        />
      </div>
      {error && <div className={css.error}>{error}</div>}
    </div>
  );
}; 